import { Button } from '@/shared/ui/Button'

export interface TopBarProps {
  onOpenNav: () => void
}

/**
 * Barra superiore, solo sotto i 1024px.
 *
 * Porta un comando e uno solo: aprire la navigazione, che a quelle larghezze
 * è un pannello a scomparsa. Tutto il resto — crediti, tema, identità,
 * registro — sta ai piedi del rail, dove si vede senza occupare la fascia
 * sopra il contenuto. Da `lg` in su il rail è sempre presente e questa barra
 * non ha più niente da fare: sparisce.
 */
export function TopBar({ onOpenNav }: TopBarProps) {
  return (
    <header className="border-b border-[var(--hairline)] bg-ink-900 flex h-[var(--topbar-height)] shrink-0 items-center px-3 sm:px-4 lg:hidden">
      <Button variant="quiet" size="sm" onClick={onOpenNav} aria-label="Apri la navigazione">
        ☰
      </Button>
    </header>
  )
}
